import React from "react";

const FieldIcon = ({ children }: { children?: React.ReactNode }) => {
  if (!children) {
    return null;
  }

  return <span className="field-icon">{children}</span>;
};

export default FieldIcon;
